import { render, staticRenderFns } from "./TextReduction.vue?vue&type=template&id=d852df26&"
import script from "./TextReduction.vue?vue&type=script&lang=js&"
export * from "./TextReduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d852df26')) {
      api.createRecord('d852df26', component.options)
    } else {
      api.reload('d852df26', component.options)
    }
    module.hot.accept("./TextReduction.vue?vue&type=template&id=d852df26&", function () {
      api.rerender('d852df26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/TextReduction.vue"
export default component.exports